import React, { useCallback, useEffect, useRef } from 'react';
import ChatFeed from '../../components/UI/ChatFeed/ChatFeed';
import MessagePosition from '../../components/UI/ChatFeed/messagePosition';
import Control from '../../components/UI/Control/Control';
import './LiveChatWindow.css';

const LiveChatWindow = ({
    selectedConversation,
    conversationId,
    messages,
    sendMessage,
    overwriteChatInput,
    sessionId,
    clearOverwrite,
}) => {
    const chatInputRef = useRef();

    const onKeyPress = useCallback(
        e => {
            if (e.key === 'Enter' && sendMessage) {
                if (e.target.value.trim()) {
                    sendMessage(sessionId, e.target.value, conversationId);
                }
                e.target.value = '';
            }
        },
        [sendMessage, sessionId, conversationId]
    );

    const chatMessages =
        Array.isArray(messages) && messages?.length
            ? messages
                  .filter(msg => msg.type === 'TEXT')
                  .map(msg => {
                      let messagePosition = MessagePosition.CENTER;
                      let senderName = '';
                      if (msg.userMessage === false) {
                          senderName = 'System';
                      } else if (msg.customerId) {
                          messagePosition = MessagePosition.LEFT;
                          senderName = `Client ${
                              sessionId.length < 8 ? sessionId : sessionId.substring(0, 7) + '...'
                          }`;
                          // operator or bot message
                      } else if (msg.sentByUser || (!msg.customerId && !msg.sentByUser)) {
                          messagePosition = MessagePosition.RIGHT;
                          if (!msg.customerId && !msg.sentByUser) {
                              senderName = 'chatbot';
                          } else {
                              senderName = 'You';
                          }
                      }

                      return { ...msg, messagePosition, senderName };
                  })
            : [];

    useEffect(() => {
        const inputRefCurrent = chatInputRef.current;
        if (inputRefCurrent && conversationId) {
            inputRefCurrent.value = '';
        }
        return () => {
            // clear input on unmount
            if (inputRefCurrent) {
                inputRefCurrent.value = '';
            }
        };
    }, [chatInputRef, conversationId]);

    useEffect(() => {
        if (overwriteChatInput && overwriteChatInput.content && chatInputRef.current) {
            chatInputRef.current.value = overwriteChatInput.content;
            clearOverwrite();
        }
    }, [overwriteChatInput, clearOverwrite]);

    return (
        <>
            <ChatFeed
                chatFeedContainerStyle={{ height: "100%", padding: "10px" }}
                messages={chatMessages}
            />

            <div className="px-2 w-100 mt-2">
                {!selectedConversation?.conversationEnded ? (
                    <Control
                        ref={chatInputRef}
                        autocomplete="off"
                        name="operatormessage"
                        inputClasses="mt-2"
                        type="text"
                        placeholder="Your message.."
                        onKeyPress={onKeyPress}
                    />
                ) : (
                    <Control
                        autocomplete="off"
                        name="operatormessage"
                        inputClasses="mt-2"
                        type="text"
                        placeholder="Conversation ended"
                        disabled={true}
                    />
                )}
            </div>
        </>
    );
};

export default LiveChatWindow;
